import { useState } from 'react';
import { Button, Input } from '@fluentui/react-components';
import { Building24Regular } from '@fluentui/react-icons';
import TenantSelector from './TenantSelector';
import type { GetTenantsFn, ITenantLike } from './types';

export interface TenantPickerProps {
  getTenants?: GetTenantsFn;
  tenantId?: number;
  tenantName?: string;
  onSelected: (tenant: ITenantLike) => void;
  disabled?: boolean;
  placeholder?: string;
  ariaLabel?: string;
}

const TenantPicker = ({
  getTenants,
  tenantId,
  tenantName,
  onSelected,
  disabled,
  placeholder = 'Click to pick a tenant',
  ariaLabel = 'Pick tenant',
}: TenantPickerProps) => {
  const [open, setOpen] = useState(false);
  const [pickedName, setPickedName] = useState<string>();
  const display = pickedName ?? tenantName ?? '';

  return (
    <div style={{ width: '100%' }}>
      <div style={{ display: 'flex', gap: 4, width: '100%' }}>
        <Input
          readOnly
          disabled={disabled}
          value={display}
          style={{ flex: 1, minWidth: 0 }}
          placeholder={disabled ? '' : placeholder}
          onClick={() => {
            if (!disabled) setOpen(true);
          }}
        />
        <Button
          appearance="subtle"
          icon={<Building24Regular />}
          disabled={disabled}
          onClick={() => setOpen(true)}
          aria-label={ariaLabel}
        />
      </div>
      {!disabled && getTenants && (
        <TenantSelector
          isOpen={open}
          onDismiss={() => setOpen(false)}
          getTenants={getTenants}
          selectedTenantId={tenantId}
          onTenantSelected={(tenant) => {
            setPickedName(tenant.name);
            onSelected(tenant);
            setOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default TenantPicker;
